<template>
    <div id="createDhlShipmentId">
        <a-modal v-model="visible" :footer="null" :title="$t('soPage.labelCreateDhlShipmentId')" width="40%">
            <a-form :form="form01">
                <a-row>

                    <a-col span="6" offset="1">
                        <a-form-item class="genericFrom">
                            <b>{{ $t('soPage.labelShipmentReference') }}:</b>
                            <a-input size="small" v-model="shipmentReference"></a-input>
                        </a-form-item>
                    </a-col>

                    <a-col span="3" offset="1">
                        <a-form-item class="genericFrom">
                            <a-row><b> </b><br/></a-row>
                            <a-row>
                                <a-button class="fonterButton" type="primary" size="small" @click="doSubmit">{{ $t('soPage.labelConfirm') }}</a-button>
                            </a-row>
                        </a-form-item>
                    </a-col>

                </a-row>
            </a-form>

        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'

    export default {
        data() {
            return {
                visible: false,
                orderNo: "",
                orderUids: [],
                form01: this.$form.createForm(this),
                shipmentReference: "",

            }
        },

        methods: {
            // init
            show(orderUids) {
                this.orderUids = orderUids;
                this.visible = true;
                this.form01.resetFields();
                this.shipmentReference = "";

            },

            doSubmit() {
                this.form01.validateFields((err, val) => {
                    if (!err) {
                        let shipmentReference = this.shipmentReference;
                        if (shipmentReference == undefined || shipmentReference == null || shipmentReference.trim() == '') {
                            this.$customMessage.warning(this.$t('soPage.msgShipmentReferenceIsNull'));
                            return;
                        }

                        let params = new FormData();
                        params.append("orderUids", this.orderUids);
                        params.append("shipmentReference", shipmentReference);

                        ajax.post(api.CREATE_DHL_SHIPMENT_ID, params).then(res => {
                            if (res.code == 200) {
                                this.$message.success(this.$t('cfs.operationSuccess'));
                                this.form01.resetFields();
                                this.visible = false;
                            } else {
                                this.$customMessage.error(res.msg);
                            }
                        });

                    }
                });
            },

            cancel() {
                this.form01.resetFields();
                this.visible = false;
            },

        }
    }
</script>